import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

var ConsoleLogHTML = require('console-log-html');

ReactDOM.render(
  <React.StrictMode>
    <App />
    <ul id="console-log"></ul>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();

// ConsoleLogHTML.connect(document.getElementById("console-log"))